function checkNumberForError(numberStr: string, parseFn: (numStr: string) => number, config: { gt?: number; lt?: number; attrName?: string; }): string[] {
  const {
    gt,
    lt,
  } = config;
  let {attrName} = config;
  if (!attrName) {
    attrName = 'Number';
  }

  const errors = [];
  const num = parseFn(numberStr.trim());
  if (isNaN(num)) {
    errors.push(attrName + ' is invalid');
  }

  if (gt !== undefined && num <= gt) {
    errors.push(`${attrName} cannot be less than ${gt}`);
  }

  if (lt !== undefined && num >= lt) {
    errors.push(`${attrName} cannot be greater than ${lt - 1}`);
  }

  return errors;
}

export function checkFloatForError(floatStr: string, config: { gt?: number; lt?: number; attrName?: string; }) {
  return checkNumberForError(floatStr, parseFloat, config);
}

export function checkIntForError(intStr: string, config: { gt?: number; lt?: number; attrName?: string; }) {
  return checkNumberForError(intStr, parseInt, config);
}

interface StringValidationConfig {
  attrName?: string;
  minLength?: number;
  maxLength?: number;
  required?: boolean;
}

export function checkStringForError(str: string | null | undefined, config: StringValidationConfig = {}): string[] {
  let { attrName } = config;
  const {
    minLength,
    maxLength,
    required,
  } = config;

  if (!attrName) {
    attrName = 'field';
  }

  if (typeof(str) !== 'string') {
    return [`${attrName} is not a string`];
  }

  if (required && !str) {
    return [`${attrName} is required`];
  }

  const errors = [];
  const trimmed = str.trim();
  if (minLength !== undefined && trimmed.length < minLength) {
    errors.push(`${attrName} must be at least ${minLength} in length`);
  }

  if (maxLength !== undefined && trimmed.length > maxLength) {
    errors.push(`${attrName} only can have up to ${maxLength} characters`);
  }

  return errors;
}